"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.mask = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var mask = function mask(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/(0, _react.css)("background-color:rgba(", theme.color.monochrome.black_rgba, ", 0.8);position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:auto;z-index:1000;" + (process.env.NODE_ENV === "production" ? "" : ";label:mask;"));
};

exports.mask = mask;

var narrow = function narrow(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;background-color:", theme.color.monochrome.superLight, ";max-width:", (0, _util.rem)(440), ";position:absolute;right:0;height:100%;width:100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:narrow;"));
};

var wide = function wide(theme) {
  return /*#__PURE__*/(0, _react.css)(narrow(theme), ";max-width:", (0, _util.rem)(740), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:wide;"));
};

var wideXL = function wideXL(theme) {
  return /*#__PURE__*/(0, _react.css)(narrow(theme), ";max-width:", (0, _util.rem)(960), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:wideXL;"));
};

var header = function header(theme) {
  return /*#__PURE__*/(0, _react.css)("background:", theme.color.primary.info, ";background:-moz-linear-gradient(\n    -45deg,\n    ", theme.color.primary.info, " 0%,\n    #9574ff 55%,\n    #9a80f4 100%\n  );background:-webkit-linear-gradient(\n    -45deg,\n    ", theme.color.primary.info, " 0%,\n    #9574ff 55%,\n    #9a80f4 100%\n  );background:linear-gradient(\n    135deg,\n    ", theme.color.primary.info, " 0%,\n    #9574ff 55%,\n    #9a80f4 100%\n  );font-family:", theme.font.secondary, ";font-weight:", theme.fontWeight.bold, ";padding:", theme.spacing['7'], " ", theme.spacing['11'], " ", theme.spacing['7'], " ", theme.spacing['12'], ";display:flex;justify-content:space-between;align-items:center;color:", theme.color.monochrome.white, ";&>h4{color:inherit;}&>button{color:inherit;background-color:rgba(", theme.color.monochrome.black_rgba, ", 0.1);border-radius:", theme.spacing['3'], ";width:", theme.spacing['14'], ";height:", theme.spacing['14'], ";padding:", theme.spacing['3'], ";transition:background-color 0.275s;}button:hover{background-color:rgba(", theme.color.monochrome.black_rgba, ", 0.25);}svg{width:100%;height:100%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:header;"));
}; // Main content style


var main = /*#__PURE__*/(0, _react.css)("flex:1;overflow:auto;padding:0 ", (0, _util.rem)(24), " ", (0, _util.rem)(24), " ", (0, _util.rem)(24), ";position:relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:main;"));
var base = process.env.NODE_ENV === "production" ? {
  name: "1hn5qfh",
  styles: "position:fixed;z-index:2000;width:100%;height:100%;top:0;right:0"
} : {
  name: "qccckc-base",
  styles: "position:fixed;z-index:2000;width:100%;height:100%;top:0;right:0;label:base;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var preLoadedState = process.env.NODE_ENV === "production" ? {
  name: "1wnowod",
  styles: "display:flex;align-items:center;justify-content:center"
} : {
  name: "st75pu-preLoadedState",
  styles: "display:flex;align-items:center;justify-content:center;label:preLoadedState;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var loadingBar = function loadingBar(theme) {
  return /*#__PURE__*/(0, _react.css)("position:absolute;left:0;right:0;top:0;height:", theme.spacing[3], ";background-color:", theme.color.primary.brand, ";transform-origin:left center;transition:transform 0.3s ease-in-out;" + (process.env.NODE_ENV === "production" ? "" : ";label:loadingBar;"));
};

var loadingText = process.env.NODE_ENV === "production" ? {
  name: "p9rzxl",
  styles: "opacity:0;visibility:hidden;transition:opacity 0.2s ease-in-out"
} : {
  name: "15lkipd-loadingText",
  styles: "opacity:0;visibility:hidden;transition:opacity 0.2s ease-in-out;label:loadingText;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var showText = process.env.NODE_ENV === "production" ? {
  name: "nk3zlf",
  styles: "opacity:1;visibility:visible"
} : {
  name: "125du4h-showText",
  styles: "opacity:1;visibility:visible;label:showText;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  base: base,
  header: header,
  main: main,
  narrow: narrow,
  wide: wide,
  wideXL: wideXL,
  preLoadedState: preLoadedState,
  loadingBar: loadingBar,
  loadingText: loadingText,
  showText: showText
};
exports.styles = styles;
//# sourceMappingURL=Drawer.styles.js.map